module.exports = __webpack_public_path__ + "assets/img/help_noeBtn.5e41124c.png";